import { useEffect, useState } from 'react';

import {
  GroupItem,
  GroupMemberItem,
  LocationSharingApi,
} from '@deckee/api-app-main';
import apiConfiguration from '../../../../services/backend/apiConfiguration';
import { useSelector } from 'react-redux';
import { getAllSignalsSharedWithCurrentMember } from '../../../../services/store/modules/signal';
import { Signal } from '../../../../services/store/modules/signal/models';
import { selectCurrentMemberId } from '../../../../services/store/modules/backend-service';

const api = new LocationSharingApi(apiConfiguration);

interface GroupMemberWithSignal extends GroupMemberItem {
  signal?: Signal;
}

interface GroupItemWithSignals extends GroupItem {
  members: GroupMemberWithSignal[];
}

const useMemberGroups = () => {
  const [apiGroups, setApiGroups] = useState<GroupItem[]>([]);
  const currentMemberId = useSelector(selectCurrentMemberId);
  const [groups, setGroups] = useState<GroupItemWithSignals[]>([]);
  const [error, setError] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  // Get all signals from the store
  const publicSignals = useSelector(getAllSignalsSharedWithCurrentMember);

  useEffect(() => {
    if (!currentMemberId) {
      setGroups([]);
      return;
    }

    const groupsWithSignals = apiGroups
      .filter((group) =>
        group.members?.some((member) => member.memberId === currentMemberId),
      )
      .map((group) => ({
        ...group,
        members: group.members.map((member) => ({
          ...member,
          signal: publicSignals.find(
            (signal) => signal.memberid === member.memberId,
          ),
        })),
      }));
    setGroups(groupsWithSignals);
  }, [apiGroups, publicSignals, currentMemberId]);

  useEffect(() => {
    api
      .getMyGroups()
      .then((response) => {
        setApiGroups(response.data);
      })
      .catch((error) => {
        setError(true);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  return { groups, error, isLoading: isLoading || !currentMemberId };
};

export default useMemberGroups;
